
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.203 2.79a.91.91 0 01-.68-.282A1.016 1.016 0 01.25 1.78c0-.291.091-.531.273-.718a.898.898 0 01.68-.29c.271 0 .498.097.68.29a.988.988 0 01.273.718c0 .292-.09.534-.273.727a.91.91 0 01-.68.281zm2.703 3.179a.91.91 0 01-.68-.282 1.016 1.016 0 01-.273-.726c0-.292.091-.531.274-.719a.898.898 0 01.68-.289c.27 0 .497.096.679.29a.988.988 0 01.273.718c0 .292-.09.534-.273.726a.91.91 0 01-.68.282zm2.781 3.18a.91.91 0 01-.68-.282 1.016 1.016 0 01-.273-.726c0-.292.092-.532.274-.72a.898.898 0 01.68-.288c.27 0 .497.096.68.289a.988.988 0 01.273.719c0 .291-.092.533-.274.726a.91.91 0 01-.68.281z","fill":"currentColor"}})])
          )
        }
      }
    